import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Installation } from '@core/models';
import { InstallationInsightsContentComponent } from '@custom-components/sections/installation-insights/installation-insights-content.component';

@Component({
  selector: 'xemex-installation-insights-tab',
  imports: [InstallationInsightsContentComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<xemex-installation-insights-content [installation]="installation()" />`,
})
export class InstallationInsightsTabComponent {
  installation = input.required<Installation>();
}
